const Environments = {
  COOKIE_HASH: process.env.REACT_APP_COOKIE_HASH!,
  API_BASE_URL: process.env.REACT_APP_API_BASE_URL!,
};

export default Environments;
